import './App.css';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/poppins/100.css';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import AllRoutes from './components/Routes/AllRoutes';
import useAutoLogout from './hooks/useAutoLogout';
import ScrollToTop from './ScrollToTop';

function AutoLogoutHandler() {
  useAutoLogout();
  return null;
}

function App() {
  return (
      <BrowserRouter>
          <ScrollToTop />
          <AutoLogoutHandler />
          <ToastContainer
              position="top-center"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              pauseOnHover
              style={{
                  position: 'fixed',
                  top: '10px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 99999,
                  width: '90vw',
                  maxWidth: '360px',
              }}
              toastStyle={{
                  backgroundColor: '#ffffff',
                  color: '#222222',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: '14px',
              }}
          />
          <AllRoutes />
      </BrowserRouter>
  );
}

export default App;